import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { IncomeConceptModel } from 'src/app/models/wallet/income-concept.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { IncomeConceptService } from 'src/app/services/wallet/income-concept.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-register-income-concept',
  templateUrl: './register-income-concept.component.html',
  styleUrls: ['./register-income-concept.component.scss'],
  standalone: false
})
export class RegisterIncomeConceptComponent implements OnInit {

  branchId: number = 0;
  disabledForm: boolean = false;
  formIncomeConcept: FormGroup = new FormGroup({});
  incomeConceptContract: IncomeConceptModel = new IncomeConceptModel();
  incomeConceptId: number = 0;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  nameWindow: string = 'Captura Conceptos Ingreso';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = 'income-concept';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private incomeConceptService: IncomeConceptService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new IncomeConceptModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.incomeConceptId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeBranch(branchId: number) {
    this.branchId = branchId;
    this.resetContract();
  }

  async changeCode(code: number) {
    this.branchId = this.formIncomeConcept.get('branchId')?.value;
    if (!this.branchId) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    await this.getIncomeConceptByKeys(this.branchId, code);
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear conceptos ingreso.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract();
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar conceptos ingreso.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.incomeConceptId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un concepto de ingreso.');
      return;
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar el concepto de ingreso?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (!result.isConfirmed) return;
    try {
      await firstValueFrom(this.incomeConceptService.deleteIncomeConcept(this.incomeConceptId));
      this.createNewRegister();
      this.toastHandlerService.showToast('success', 'El concepto de ingreso fue eliminado exitosamente.');
    } catch (error) {
      console.error('Error al eliminar el concepto de ingreso.', error);
    }
  }

  async getAllBranchesForSelect() {
    try {
      const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
      this.listBranches = response;
    } catch (error) {
      console.error('Error al obtener la lista de suscursales.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formIncomeConcept.get("branchId")?.value;
    if (!this.branchId) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    this.handleIncomeConceptNavigation(buttonClick, this.branchId)
  }

  async getIncomeConceptByKeys(branchId: number, code: number) {
    try {
      const response = await firstValueFrom(this.incomeConceptService.getIncomeConceptByKeys(branchId, code));
      this.incomeConceptContract = response;
      this.validateForm(this.incomeConceptContract);
      this.location.replaceState(`/${this.url}/register/${this.incomeConceptId}`);
    } catch (error) {
      console.error('Error al obtener el concepto de ingreso por claves.', error);
    }
  }

  async getIncomeConceptById() {
    try {
      const response = await firstValueFrom(this.incomeConceptService.getIncomeConceptById(this.incomeConceptId));
      this.incomeConceptContract = response;
      this.validateForm(this.incomeConceptContract);
      this.location.replaceState(`/${this.url}/register/${this.incomeConceptId}`);
    } catch (error) {
      console.error('Error al obtener el concepto de ingreso por id.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.userAuthenticatedService.branchObservable.pipe(filter(branch => !!branch &&
        branch.branchId !== 0)));
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getAllBranchesForSelect(),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.incomeConceptId) {
      await this.getIncomeConceptById();
    } else {
      this.createNewRegister();
    }
  }

  async handleIncomeConceptNavigation(buttonClick: any, branchId: number) {
    const code = this.formIncomeConcept.get("code")?.value;
    const actionMap: Record<string, () => Promise<IncomeConceptModel>> = {
      first: () =>
        firstValueFrom(this.incomeConceptService.getFirstIncomeConceptByKeys(branchId)),
      previus: () =>
        firstValueFrom(this.incomeConceptService.getPreviusIncomeConceptByKeys(branchId, code)),
      next: () =>
        firstValueFrom(this.incomeConceptService.getNextIncomeConceptByKeys(branchId, code)),
      last: () =>
        firstValueFrom(this.incomeConceptService.getLastIncomeConceptByKeys(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
      return;
    }
    try {
      const incomeConcept = await action();
      this.incomeConceptId = incomeConcept.incomeConceptId;
      this.incomeConceptContract = incomeConcept;
      this.validateForm(this.incomeConceptContract);
      this.location.replaceState(`/${this.url}/register/${this.incomeConceptId}`);
    } catch (error) {
      console.error(`Error al buscar el concepto de ingreso (${buttonClick.target.id}).`, error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formIncomeConcept.valid) {
      const modelIncomeConcept = this.formIncomeConcept.getRawValue() as IncomeConceptModel;
      if (modelIncomeConcept.incomeAccount == '') modelIncomeConcept.incomeAccount = null;
      if (this.incomeConceptId == 0) {
        try {
          const response = await firstValueFrom(this.incomeConceptService.createIncomeConcept(modelIncomeConcept));
          this.incomeConceptId = response.incomeConceptId;
          this.incomeConceptContract = response;
          this.validateForm(this.incomeConceptContract);
          this.location.replaceState(`/${this.url}/register/${this.incomeConceptId}`);
          this.toastHandlerService.showToast('success', `El concepto de ingreso fue creado exitosamente.`);
        } catch (error) {
          console.error('Error al crear el concepto de ingreso.', error);
        }
      } else {
        this.incomeConceptContract.name = modelIncomeConcept.name;
        this.incomeConceptContract.incomeAccount = modelIncomeConcept.incomeAccount;
        try {
          const response = await firstValueFrom(this.incomeConceptService.updateIncomeConcept(this.incomeConceptContract));
          this.incomeConceptContract = response;
          this.validateForm(this.incomeConceptContract);
          this.toastHandlerService.showToast('success', `El concepto de ingreso fue modificado exitosamente.`);
        } catch (error) {
          console.error('Error al actualizar el concepto de ingreso.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'La Sucursal es obligatoria.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      code: {
        required: 'El Código es obligatorio.',
        min: 'Debe seleccionar un Código válido.'
      },
      name: {
        required: 'El Nombre es obligatorio.',
        maxlength: 'El Nombre no puede tener más de 70 caracteres.'
      },
      incomeAccount: {
        maxlength: 'La Cuenta de Ingreso no puede tener más de 10 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formIncomeConcept.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  resetContract() {
    this.incomeConceptId = 0;
    this.incomeConceptContract = new IncomeConceptModel();
    this.incomeConceptContract.branchId = this.branchId;
    this.validateForm(this.incomeConceptContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormPermision() {
    if (this.permissionUpdatable) {
      this.disabledForm = false;
      setTimeout(() => {
        this.formIncomeConcept.enable();
        const controlCode = this.formIncomeConcept.controls['code'];
        this.incomeConceptId != 0 ? controlCode.enable() : controlCode.disable();
      });
    } else {
      this.disabledForm = true;
      setTimeout(() => {
        this.formIncomeConcept.disable();
        this.formIncomeConcept.controls["code"].enable();
      });
    }
  }

  validateForm(incomeConceptModel: IncomeConceptModel) {
    this.formIncomeConcept = this.formBuilder.group({
      branchId: [incomeConceptModel.branchId, [Validators.required, Validators.min(1)]],
      code: [incomeConceptModel.code, [Validators.required, Validators.min(1)]],
      name: [incomeConceptModel.name, [Validators.required, Validators.maxLength(70)]],
      incomeAccount: [incomeConceptModel.incomeAccount, [Validators.maxLength(10)]]
    });
    this.updateFormPermision();
  }

  validateFormControls() {
    Object.keys(this.formIncomeConcept.controls).forEach((key) => {
      const control = this.formIncomeConcept.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
